import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div\n  class=\"menuContent {{if @isOpen \'menuContent--isOpen\'}}\"\n  data-test-menu-content\n  ...attributes\n>\n  {{yield}}\n</div>")